export async function initContactFormAutocomplete() {
    const { Autocomplete } = await google.maps.importLibrary("places");

    const locationInput = document.querySelector('[name="location"]');
    if (!locationInput) {
        return;
    }

    const autocomplete = new Autocomplete(locationInput, {
        types: ["address"],
        fields: ["address_components"],
        componentRestrictions: { country: 'us' }
    });

    autocomplete.addListener('place_changed', () => {
        const place = autocomplete.getPlace();
        if (!place || !place.address_components) return;

        // Format the address components into a clean address string
        const addressComponents = place.address_components;
        const streetNumber = addressComponents.find(component => component.types.includes('street_number'))?.long_name || '';
        const route = addressComponents.find(component => component.types.includes('route'))?.long_name || '';
        const city = addressComponents.find(component => component.types.includes('locality'))?.long_name || '';
        const state = addressComponents.find(component => component.types.includes('administrative_area_level_1'))?.short_name || '';
        const zipCode = addressComponents.find(component => component.types.includes('postal_code'))?.long_name || '';

        // Combine street number and route
        const streetAddress = [streetNumber, route].filter(Boolean).join(' ');

        // Combine components into a formatted address
        const formattedAddress = [streetAddress, city, state, zipCode]
            .filter(Boolean)
            .join(', ');

        // Update the input with the formatted address
        locationInput.value = formattedAddress;
    });
}

// Initialize when the DOM is loaded
document.addEventListener('DOMContentLoaded', initContactFormAutocomplete); 